import { render, staticRenderFns } from "./SalesSelectCustomer.vue?vue&type=template&id=5efaa6f0&scoped=true&"
import script from "./SalesSelectCustomer.vue?vue&type=script&lang=js&"
export * from "./SalesSelectCustomer.vue?vue&type=script&lang=js&"
import style0 from "./SalesSelectCustomer.vue?vue&type=style&index=0&id=5efaa6f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efaa6f0",
  null
  
)

export default component.exports